<template>
  <div>
    <!-- <div class="bg-[#fff] shadow" v-if="$route.path.indexOf('/external/sign') == -1 && $route.path.indexOf('/external/CaSeal') == -1 && $route.path.indexOf('/external/h5pay') == -1"> -->
    <div class="bg-[#fff] shadow" v-if="hiddenHeader.indexOf($route.path) == -1">
      <div class="mx-[auto] w-[1024] h-[57] flex items-center justify-between"
        v-if="!['/external/qingdaoJump'].indexOf($route.path) > -1">
        <div v-if="copyrightStatus == 0"></div>
        <div v-if="copyrightStatus == 2" class="flex items-center">
          <i v-if="conf.logoIcon" class="iconfont-logo t-[30] t-[theme]" :class="conf.logoIcon"></i>
          <img v-else class="w-[28] mr-[5]" :src="getCityAssetsFile('logo.png')" alt="" />
          <span class="t-[#303133] t-[24] pl-[5] font-500">{{
            $route.query.taction && $route.query.taction == "CustomsInsure"
              ? "海关关税电子保函平台"
              : conf.name
          }}</span>
        </div>
        <template v-if="copyrightStatus == 1">
          <a :href="copyright.htmlLogoHref" v-show="copyright.htmlLogoHref" target="_blank" class="block">
            <el-image :src="copyright.htmlLogo" class="w-[150px] h-[50px] block"></el-image>
          </a>
        </template>
        <div class="flex-center" v-if="
          [
            '/external/lawsuit/completeByJump',
            '/external/lawsuit/order',
          ].indexOf($route.path) > -1
        ">
          <div class="flex-center">
            <p class="pr-[8] t-[12] t-[#909399]">
              已申请需查看申请记录或继续申请，点击 订单查询
            </p>
            <a href="/#/order/lawsuit/list" target="_blank">
              <el-button size="mini" class="">订单查询</el-button></a>
          </div>
          <el-dropdown class="headimg-box pl-[10]" @command="handleCommand" v-if="current.user.realName">
            <div class="flex items-center cursor-pointer">
              <p class="px-[4] t-[14] max-w-[100] truncate">
                {{ current.user && current.user.realName }}
              </p>
              <p class=""><i class="icon">&#xe747;</i></p>
            </div>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item command="exit">退出登录</el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </div>
      </div>
    </div>
    <div class="w-[1024] mx-[auto] my-[8] bg-[#fff]" v-if="
      stepVisibleRouter.indexOf($route.path) > -1 &&
      $route.query.taction &&
      $route.query.taction.indexOf('Cancel') == -1
    ">
      <dg-step :active="active"></dg-step>
    </div>
    <keep-alive :include="cachedViews">
      <router-view ref="routerView" v-loading="showLoading" :key="$route.fullPath" />
    </keep-alive>

    <div v-if="hiddenHeader.indexOf($route.path) == -1">
      <!-- 联系方式 -->
      <template v-if="hiddenContact.indexOf($route.path) == -1">
        <dg-xiaojin v-if="!showIframe()" top="30%" right="0" showblank="open" v-model="copyright"></dg-xiaojin>
        <dg-contact v-else top="30%" right=""></dg-contact>
      </template>
      <!-- 底部广告 -->
      <dg-gg v-if="showAd.includes($route.path)" class="w-[1024] mx-[auto] mt-[10]"></dg-gg>
      <!-- 版权信息 -->
      <!-- <dg-copyright
        v-if="copyrightStatus == 2"
        :copyrightWidth="!showMobile() ? 'w-[1024]' : ''"
        class="pt-[20] pb-[20]"
      ></dg-copyright>
      <div
        id="copyright"
        class="w-[1024] mx-[auto] text-center t-[#788593] pb-[20] pt-[20]"
        v-html="copyright.htmlCopyright"
      ></div> -->

      <div id="copyright" v-if="copyright.htmlCopyright"
        class="w-[1024] mx-[auto] text-center t-[#788593] pb-[20] pt-[20]" v-html="copyright.htmlCopyright"></div>
      <dg-copyright v-else :copyrightWidth="!showMobile() ? 'w-[1024]' : ''" class="pt-[20] pb-[20]"></dg-copyright>
    </div>
  </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
// import { setval } from "@/assets/js/utils";
export default {
  mixins: [mixin],
  data() {
    return {
      // showCopyright: false,
      hiddenCopyright: ["/external/channel", "/external/biddingChannel"],
      // '/complete',
      // '/external/safe/complete',//以上路由隐藏平台版权
      active: 1,
      showLoading: false,
      guaranteeChannelHtmlPage: false,
      current: {
        user: { realName: "" },
      },
      copyright: {
        customerServiceMobile: "",
        customerServicePhone: "",
        customerServicePhone2: "",
        customerServiceTime: "",
        customerServiceTime2: "",
        customerServiceWechatQrcode: "",
        htmlCopyright: "",
        htmlIcon: "",
        htmlLogo: "",
        htmlLogoHref: "",
        htmlTitle: "",
      },
      hiddenHeader: [
        "/external/qingdaoJump",
        "/external/sign/autograph",
        "/external/sign",
        "/external/CaSeal",
        "/external/h5pay",
        "/external/sign/signature",
        "/external/sign/signature/",
        "/external/sign/signatureSuccess",
        "/external/security/inquiry",
        "/external/registry",
        "/external/registrySuccess",
        "/external/visitLawyerSms",
      ],
      showAd: [
        "/external/loan/detail",
        "/external/insurance/quote",
        "/external/contract/detail",
        "/external/peasant/detail",
        "/external/advance/detail",
        "/external/owner/detail",
        "/external/quality/detail",
        "/external/govContract/detail",
        "/external/govAdvance/detail",
        "/external/bidSecurity/detail",
        "/external/govBidSecurity/detail",
        "/external/bidding/detail",
        "/external/safe/detail",
        "/external/lawsuit/detail",
        "/external/customs/detail",
        "/external/cultural/detail",
      ],
      copyrightStatus: 0, //  0 未加载、1 接口信息、2 本地信息
      hiddenContact: [
        "/external/sign/autograph",
        "/external/sign/signature",
        "/external/sign/signatureSuccess",
        "/external/webSeal",
        "/external/security/inquiry",
        "/external/registry",
        "/external/registrySuccess",
        "/external/visitLawyerSms",
      ],
      cachedViews: [
        "qualificationList",
        "bidSecurityApply",
        "externalContractApply",
        "externalPeasantApply",
        "externalInsuranceConfirm",
      ],
      stepVisibleRouter: [
        "/external/customs/apply",
        "/external/offlineSignature",
        "/external/peasant/complete",
        "/external/govContract/complete",
        "/external/lawsuit/onlineSignature",
        "/external/contract/complete",
        "/external/quality/complete",
        "/external/safe/complete",
        "/external/signList",
        "/external/insurance/quote",
        "/external/insurance/confirm",
        "/external/selectPaytype",
        "/external/safe/apply",
        "/external/lawsuit/apply",
        "/external/contract/confirm",
        "/external/contract/apply",
        "/external/signature",
        "/external/channel",
        "/external/bidChannel",
        "/external/selectSeal",

        "/external/basicPay",
        "/external/bidSecurity/apply",
        "/external/qualification/list",
        "/external/qualification/createOrUpdate",
        "/external/customs/complete",
        "/external/customs/confirm",
        "/external/signPage",
        "/external/offlineSignPage",
        "/external/advance/complete",
        "/external/govAdvance/complete",
        "/external/owner/complete",
        "/external/insurance/confirmation",
        "/external/bidding/complete",

        "/external/biddingChannel",

        "/external/cultural/complete",
        // "/external/lawsuit/complete"
        "/external/teamRisk/complete",
        "/external/allRisk/complete",
      ],
      formData: {
        taction: this.$route.query.taction || "",
        tradeNo: this.$route.query.tradeNo || "",
        token: this.$route.query.token || "",
        tv: this.$route.query.tv || "",
        udp: this.$route.query.udp || "",
      },
    };
  },
  watch: {
    $route: {
      handler() {
        // 路由变化时，获取版权信息
        this.getCopyright();
        this.$nextTick(() => {
          if (this.$refs.routerView.stepActive && this.$route.query.taction) {
            this.active =
              this.$refs.routerView.stepActive[this.$route.query.taction];
          }
        });
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    handleCommand(command) {
      if (command == "exit") {
        ajax.post({
          url: "/customer/auth/logout",
          data: {},
          self: this,
          success: (res) => {
            if (res) {
              sessionStorage.removeItem("menuChild");
              this.back({ path: "/login" });
            }
          },
        });
      }
    },
    showMobile() {
      if (window.innerWidth <= 768) {
        return true;
      }
    },

    // 获取版权信息
    getCopyright() {
      if (this.hiddenHeader.indexOf(this.$route.path) > -1) {
        return;
      }
      ajax.post({
        url: "/customer/baohanOrder/external/channelHtmlPageInfo",
        data: { ...this.formData },
        self: this,
        success: (res) => {
          if (res) {
            this.copyright = res;
            document.title = this.copyright.htmlTitle || "保函申请";
            var favicon = document.querySelector('link[rel="icon"]');
            if (favicon !== null && this.copyright.htmlIcon) {
              favicon.href = this.copyright.htmlIcon;
            } else {
              favicon = document.createElement("link");
              favicon.rel = "shortcut icon";
              if (this.copyright.htmlIcon) {
                favicon.href = this.copyright.htmlIcon;
              }
              document.head.appendChild(favicon);
            }
            if (this.$route.path.indexOf('/external/channel') > -1 || this.$route.path.indexOf('/external/biddingChannel') > -1 || this.$route.path.indexOf('/external/bidChannel') > -1 || this.$route.path.indexOf('/external/lawsuit/completeByJump') > -1 || this.$route.path.indexOf('complete') > -1) {
              this.copyrightStatus = 2
            } else {
              this.copyrightStatus = 1;
            }
          }
        },
      });
    },
  },

  mounted() {
    this.$root.$on("current_external", (res) => {
      this.current = res;
    });
    // Mirror.watch(`setCopyright`, (key, value) => {
    //   if (value && Object.keys(value).length) {
    //     this.copyrightStatus = 1;
    //   } else {
    //     this.copyrightStatus = 2;
    //   }
    //   setval(this.copyright, value);
    //   console.log('this.copyright', this.copyright);
    // });
  },
  created() {
    this.$nextTick(() => {
      if (this.$refs.routerView.stepActive && this.$route.query.taction) {
        this.active =
          this.$refs.routerView.stepActive[this.$route.query.taction];
      }
    });
    Mirror.watch("loading_external_view_open", () => {
      this.showLoading = true;
    });
    Mirror.watch("loading_external_view_close", () => {
      this.showLoading = false;
    });
  },
};
</script>
<style scoped>
.shadow {
  box-shadow: 0 3px 6px 0 rgb(197 197 197 / 14%);
}

.set-step {
  flex-shrink: 0;
  box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.12),
    0px 8px 12px -4px rgba(0, 0, 0, 0.12), 0px 4px 4px -2px rgba(0, 0, 0, 0.05),
    inset 0px -2px 0px 0px rgba(0, 0, 0, 0.08);
}
</style>
